const DASHBOARD_CONFIG = {
  PINNED_TYPE: {
    REFINER: 'refiner',
    ANALYZER: 'analyzer',
  },
  INTEGRATOR_LEVEL: {
    CAMPAIGN: 'campaign',
    AD_SET: 'ad_set',
    AD: 'ad',
  },
};

export default DASHBOARD_CONFIG;

export const INTEGRATOR_MENUS = [
  {
    label: 'Campaign',
    value: DASHBOARD_CONFIG.INTEGRATOR_LEVEL.CAMPAIGN,
  },
  {
    label: 'Ad Set',
    value: DASHBOARD_CONFIG.INTEGRATOR_LEVEL.AD_SET,
  },
  {
    label: 'Ad',
    value: DASHBOARD_CONFIG.INTEGRATOR_LEVEL.AD,
  },
];
